import { useState } from 'react';
import { Grid, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SCUIButton } from '../../atoms';
import { SCUIGeneralModal } from '../SCUIGeneralModal/SCUIGeneralModal';

export const SCUIBatchSearchModule = (props: any) => {
    const { t } = useTranslation();

    const [listModalOpen, setListModalOpen] = useState(false);

    const handleCloseModal = () => {
        setListModalOpen(false);
    };

    const handleSearch = async () => {
        if (props.isSearching) {
            return;
        }

        setListModalOpen(false);
        await Promise.resolve(props.function?.());
    };

    return (
        <>
            <SCUIGeneralModal
                width={'xs'}
                open={listModalOpen}
                onClose={handleCloseModal}
                title={t('general.batchSearch')}
                functionButtonOnClick={handleSearch}
                buttonText={props.isSearching ? `${t('general.search')}...` : t('general.search')}
                disabled={props.isSearching}
            >
                <Grid container sx={{ padding: '2rem' }}>
                    <TextField
                        sx={{ paddingBottom: '1rem' }}
                        label={props.textFieldLabel}
                        value={props.value}
                        multiline
                        rows={10}
                        onChange={(event: any) => {
                            props.setValue(event.target.value);
                        }}
                        slotProps={{ inputLabel: { shrink: true } }}
                        fullWidth
                    />
                </Grid>
            </SCUIGeneralModal>
            <SCUIButton
                text={t('general.batchSearch')}
                type="secondary"
                sizeType="fixed"
                style={{ height: '40px', marginLeft: '16px' }}
                size={'m'}
                disabled={props.isSearching}
                onClick={() => setListModalOpen(true)}
            />
        </>
    );
};
